import { BryntumGridProps } from "@bryntum/schedulerpro-react"

import useIsDesktop from "@hooks/useIsDesktop"

import { OnBeforeShowEvent } from "@pages/Jobs/JobList/views/JobTimelineView/JobTimelineView.types"

import useJobTimelineViewBryntumInstances from "./useJobTimelineViewBryntumInstances"
import useJobTimelineViewEventHandlers from "./useJobTimelineViewEventHandlers"
import useJobTimelineViewRenderers from "./useJobTimelineViewRenderers"
import useTimelineViewUnscheduledJobsUtils from "./useTimelineViewUnscheduledJobsUtils"

export default function useJobTimelineViewGridProps(): {
    desktopProps: BryntumGridProps
    mobileProps: BryntumGridProps
} {
    const { onGridCellClick } = useJobTimelineViewEventHandlers()
    const isDesktop = useIsDesktop()

    const {
        onUnscheduledJobsGridPaint,
        onUnscheduledJobsGridScroll,
        onMobileUnscheduledJobsGridPaint,
        onMobileUnscheduledJobsGridScroll,
    } = useTimelineViewUnscheduledJobsUtils()

    const { renderUnscheduledJobsCellsTooltip, renderUnscheduledJobsCells, renderUnscheduledJobsGridEmptyMessage } =
        useJobTimelineViewRenderers()

    const { unscheduledJobsGrid } = useJobTimelineViewBryntumInstances()

    const sharedProps: BryntumGridProps = {
        cls: "unscheduled-jobs-grid__bryntum-grid",
        // @ts-expect-error bad typing
        onCellClick: onGridCellClick,
        emptyText: renderUnscheduledJobsGridEmptyMessage(),
        columns: [
            {
                type: "template",
                headerRenderer: () => undefined,
                filterable: false,
                enableHeaderContextMenu: false,
                sortable: false,
                resizable: false,
                enableCellContextMenu: false,
                readOnly: true,
                template: renderUnscheduledJobsCells,
            },
        ],
    }

    const desktopProps: BryntumGridProps = {
        listeners: {
            paint: onUnscheduledJobsGridPaint,
            scroll: onUnscheduledJobsGridScroll,
        },
        cellTooltipFeature: {
            cls: "job-timeline-view__job-preview-tooltip",
            tooltipRenderer: renderUnscheduledJobsCellsTooltip,
            hideDelay: true,
            allowOver: false,
            showOnHover: true,
            hoverDelay: 0,
            textContent: true,
            scrollAction: "hide",
            align: {
                align: "r-l",
                overlap: false,
                anchor: true,
                offset: 4,
            },
            preventTooltipOnTouch: true,
            disabled: !isDesktop,
            onBeforeShow: (event: OnBeforeShowEvent) => {
                const gridInstance = unscheduledJobsGrid.current?.instance
                if (gridInstance) {
                    event.source.html = renderUnscheduledJobsCellsTooltip({
                        record: gridInstance._features.cellTooltip.lastRecord,
                    })
                }
            },
        },
        ...sharedProps,
    }

    const mobileProps = {
        listeners: {
            paint: onMobileUnscheduledJobsGridPaint,
            scroll: onMobileUnscheduledJobsGridScroll,
        },
        ...sharedProps,
    }

    return {
        desktopProps,
        mobileProps,
    }
}
